"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var combineLearningPanelUrl_1 = __importDefault(require("./combineLearningPanelUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var userContentApi_1 = require("../../mock/learningPanel/userContentApi");
var UserContentAPIs = {
    getPrimaryCourseData: function () {
        return rest_1.default.get({
            mockFunc: function () { return userContentApi_1.mockPrimaryCourseData; },
            url: (0, combineLearningPanelUrl_1.default)('/user-content/primary-course-data'),
        });
    },
    getAssignedContentData: function () {
        return rest_1.default.get({
            mockFunc: function () { return userContentApi_1.mockAssignedContentData; },
            url: (0, combineLearningPanelUrl_1.default)('/user-content/assigned-content-data'),
        });
    },
    getPrimaryCourseMetadata: function () {
        return rest_1.default.get({
            mockFunc: function () { return userContentApi_1.mockPrimaryCourseMetadata; },
            url: (0, combineLearningPanelUrl_1.default)('/user-content/primary-course-metadata'),
        });
    },
};
exports.default = UserContentAPIs;
